var _defs, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonutsSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "297mm",
    height: "210mm",
    viewBox: "0 0 297 210",
    id: "svg2361",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2358"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer101",
    fill: "#474f55",
    stroke: "none",
    transform: "matrix(0.09196477,0,0,0.09089203,3.0154344,-2.8456907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 242,556 C 139,522 77,433 76,320 75,54 429,-23 539,220 c 70,153 -35,332 -203,346 -28,2 -70,-2 -94,-10 z M 348,364 c 41,-29 19,-94 -33,-94 -21,0 -55,32 -55,51 0,13 42,59 54,59 6,0 22,-7 34,-16 z",
    id: "path2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "layer102",
    fill: "#8b7849",
    stroke: "none",
    transform: "matrix(0.09196477,0,0,0.09089203,3.0154344,-2.8456907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 219,507 c -29,-16 -54,-40 -74,-72 -26,-42 -30,-58 -30,-121 0,-64 3,-77 30,-115 113,-160 349,-99 381,98 13,82 -46,187 -123,220 -51,21 -133,17 -184,-10 z M 374,388 c 40,-35 43,-78 11,-116 -22,-26 -34,-32 -66,-32 -80,0 -115,77 -63,139 32,39 80,42 118,9 z",
    id: "path5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer103",
    fill: "#45b980",
    stroke: "none",
    style: {
      fill: "#226e13",
      fillOpacity: 1
    },
    transform: "matrix(0.09196477,0,0,0.09089203,3.0154344,-2.8456907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 219,507 C 136,463 90,346 120,255 157,143 290,81 398,125 c 168,71 168,319 0,390 -55,22 -127,19 -179,-8 z M 373,390 c 50,-39 42,-117 -15,-146 -60,-31 -128,13 -128,83 0,71 85,109 143,63 z",
    id: "path8",
    style: {
      fill: "#226e13",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer104",
    fill: "#b2b24f",
    stroke: "none",
    style: {
      fill: "#e5b54f",
      fillOpacity: 1
    },
    transform: "matrix(0.09196477,0,0,0.09089203,3.0154344,-2.8456907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 418,489 c 37,-37 72,-98 72,-127 0,-24 -41,-62 -67,-62 -13,0 -24,-8 -28,-20 -4,-11 -20,-27 -37,-36 -40,-21 -97,-6 -127,33 -21,26 -29,73 -12,73 5,0 16,11 25,25 12,18 -2,11 -46,-25 -34,-27 -68,-50 -75,-50 -18,0 -16,-17 6,-65 49,-105 183,-157 269,-105 42,26 89,100 97,153 3,23 11,52 17,64 20,40 -33,128 -96,160 l -31,15 z",
    id: "path11",
    style: {
      fill: "#e5b54f",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 382,459 c 2,-7 10,-15 17,-17 8,-3 12,1 9,9 -2,7 -10,15 -17,17 -8,3 -12,-1 -9,-9 z",
    id: "path13",
    style: {
      fill: "#e5b54f",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 210,430 c 0,-5 11,-10 25,-10 14,0 25,5 25,10 0,6 -11,10 -25,10 -14,0 -25,-4 -25,-10 z",
    id: "path15",
    style: {
      fill: "#e5b54f",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 436,391 c -7,-11 22,-23 36,-15 6,4 5,10 -3,15 -18,11 -26,11 -33,0 z",
    id: "path17",
    style: {
      fill: "#e5b54f",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer105",
    fill: "#f8bf37",
    stroke: "none",
    style: {
      fill: "#f88b12",
      fillOpacity: 1
    },
    transform: "matrix(0.09196477,0,0,0.09089203,3.0154344,-2.8456907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 448,463 c 16,-21 35,-55 42,-75 13,-44 36,-53 25,-10 -8,35 -48,93 -76,110 -17,11 -15,6 9,-25 z",
    id: "path20",
    style: {
      fill: "#f88b12",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 382,459 c 2,-7 10,-15 17,-17 8,-3 12,1 9,9 -2,7 -10,15 -17,17 -8,3 -12,-1 -9,-9 z",
    id: "path22",
    style: {
      fill: "#f88b12",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 210,430 c 0,-5 11,-10 25,-10 14,0 25,5 25,10 0,6 -11,10 -25,10 -14,0 -25,-4 -25,-10 z",
    id: "path24",
    style: {
      fill: "#f88b12",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 436,391 c -7,-11 22,-23 36,-15 6,4 5,10 -3,15 -18,11 -26,11 -33,0 z",
    id: "path26",
    style: {
      fill: "#f88b12",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 174,327 c -18,-15 -39,-27 -47,-27 -13,0 -13,-7 -4,-42 20,-79 112,-148 200,-148 77,0 167,100 167,185 v 36 l -26,-20 c -15,-12 -32,-21 -40,-21 -7,0 -27,-14 -44,-31 -27,-28 -36,-31 -72,-26 -59,8 -92,36 -98,82 l -5,38 z",
    id: "path28",
    style: {
      fill: "#f88b12",
      fillOpacity: 1
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "layer106",
    fill: "#a3ddc1",
    stroke: "none",
    transform: "matrix(0.09196477,0,0,0.09089203,3.0154344,-2.8456907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 382,459 c 2,-7 10,-15 17,-17 8,-3 12,1 9,9 -2,7 -10,15 -17,17 -8,3 -12,-1 -9,-9 z",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 210,430 c 0,-5 11,-10 25,-10 14,0 25,5 25,10 0,6 -11,10 -25,10 -14,0 -25,-4 -25,-10 z",
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 436,391 c -7,-11 22,-23 36,-15 6,4 5,10 -3,15 -18,11 -26,11 -33,0 z",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 455,256 c -11,-8 -14,-15 -8,-19 6,-4 16,0 23,8 17,21 8,28 -15,11 z",
    id: "path37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 160,250 c 0,-5 9,-10 20,-10 11,0 20,5 20,10 0,6 -9,10 -20,10 -11,0 -20,-4 -20,-10 z",
    id: "path39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 332,179 c 2,-7 10,-15 17,-17 8,-3 12,1 9,9 -2,7 -10,15 -17,17 -8,3 -12,-1 -9,-9 z",
    id: "path41"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "layer107",
    fill: "#fde7b1",
    stroke: "none",
    transform: "matrix(0.09196477,0,0,0.09089203,3.0154344,-2.8456907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 220,430 c 0,-5 7,-10 15,-10 8,0 15,5 15,10 0,6 -7,10 -15,10 -8,0 -15,-4 -15,-10 z",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 455,256 c -11,-8 -14,-15 -8,-19 6,-4 16,0 23,8 17,21 8,28 -15,11 z",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 160,250 c 0,-5 9,-10 20,-10 11,0 20,5 20,10 0,6 -9,10 -20,10 -11,0 -20,-4 -20,-10 z",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 332,179 c 2,-7 10,-15 17,-17 8,-3 12,1 9,9 -2,7 -10,15 -17,17 -8,3 -12,-1 -9,-9 z",
    id: "path50"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "layer108",
    fill: "#f6f9f1",
    stroke: "none",
    transform: "matrix(0.09196477,0,0,0.09089203,3.0154344,-2.8456907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 220,430 c 0,-5 7,-10 15,-10 8,0 15,5 15,10 0,6 -7,10 -15,10 -8,0 -15,-4 -15,-10 z",
    id: "path53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 165,250 c 3,-5 13,-10 21,-10 8,0 14,5 14,10 0,6 -9,10 -21,10 -11,0 -17,-4 -14,-10 z",
    id: "path55"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonutsSm);
export default __webpack_public_path__ + "static/media/bonuts_sm.465ba7fef01e89dd114bbf5ad6d54288.svg";
export { ForwardRef as ReactComponent };